/* eslint-disable */
import { useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";

/*import url and gateway methods */
import { postData, getData } from "utils/Gateway";
import * as url from "urlhelpers/UrlHelper";

//import translation function for language translation
import { useTranslation } from "react-i18next";

//import context
import { GlobalProvider } from "context/GlobalContext";

const ConversationFilter = () => {
  const {
    setSearchMailReciever,
    setSearchMailSender,
    setSearchMailSubject,
    setSearchMailDate,
    setSearchMailTemplateSelect,
    setSearchMailLabelSelect,
    setSearchMailReserveId,
    setReloadConversationList,
    isConversationLoading,
  } = useContext(GlobalProvider);

  const { t } = useTranslation(); //for translation
  const todayValue = new Date().toISOString().split("T")[0];
  const token = localStorage.getItem("token"); // token

  const [selectedChecked, setSelectedChecked] = useState("");

  //date range
  const [fromDate, setFromDate] = useState(todayValue);
  const [toDate, setToDate] = useState(todayValue);

  //single date
  const [selectedDate, setSelectedDate] = useState(todayValue);

  const [labelList, setLabelList] = useState([]); // for label list
  const [templateList, setTemplateList] = useState([]); //for template list

  const [recieverName, setRecieverName] = useState("");
  const [senderName, setSenderName] = useState("");

  //use state for sender and reciever select
  const [recieverList, setRecieverList] = useState([]);
  const [senderList, setSenderList] = useState([]);

  const [recieverValue, setRecieverValue] = useState(null);
  const [senderValue, setSenderValue] = useState(null);

  const [mailSubject, setmailSubject] = useState("");

  const [templateValue, setTemplateValue] = useState(null);
  const [searchedTemplate, setSearchedTemplate] = useState([]);

  const [labelValue, setLabelValue] = useState(null);
  const [searchedLabel, setSearchedLabel] = useState([]);

  const [reserveCustomerId, setReserveCustomerId] = useState("");

  /* Template selection */
  const getAllTemplates = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_TEMPLATE +
        `?token=${token}&isselect=${true}`;

      const response = await getData(requestUrl);

      console.log("template response ==>", response);

      if (response.status) {
        setTemplateList(response.data);
      }
    } catch (error) {}
  };

  //function for get all label list
  const getAllLabels = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_TAG +
        `?token=${token}&isselect=${true}`;

      const response = await getData(requestUrl);

      if (response.status) {
        setLabelList(response.data);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  //function for select radio
  const radioCheckHandler = (event) => {
    setSelectedChecked(event.target.value);
    setDateWarning(false);
  };

  //function for get all user list
  const getAllRecieverList = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_USER +
        `?token=${token}&isselect=${true}&username=${recieverName}&limit=0`;

      const response = await getData(requestUrl);

      if (response.status) {
        setRecieverList(response.data);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  //function for get all user list
  const getAllSenderList = async () => {
    try {
      let requestUrl =
        url.API_BASEURL +
        url.API_GET_ALL_USER +
        `?token=${token}&isselect=${true}&username=${senderName}&limit=0`;

      const response = await getData(requestUrl);

      if (response.status) {
        setSenderList(response.data);
      }
    } catch (error) {
      console.error(error.message);
    }
  };

  //function for reciever selection
  const recieverSelectionHandler = (val) => {
    setRecieverValue(val);
  };

  //function for sender selection
  const senderSelectionHandler = (val) => {
    setSenderValue(val);
  };

  //function for template selection
  const templateSectionHandler = (val) => {
    setTemplateValue(val);
    const templateData = val.map((data) => data.value);
    setSearchedTemplate(templateData);
  };

  //function for label selection
  const labelSectionHandler = (val) => {
    setLabelValue(val);
    const labelData = val.map((data) => data.value);
    setSearchedLabel(labelData);
  };

  //function for reset
  const resetHandler = () => {
    setRecieverName("");
    setSenderName("");
    setRecieverList([]);
    setSenderList([]);
    setRecieverValue(null);
    setSenderValue(null);
    setmailSubject("");
    setSelectedChecked("");
    setFromDate(todayValue);
    setToDate(todayValue);
    setSelectedDate(todayValue);
    setTemplateValue(null);
    setSearchedTemplate([]);
    setLabelValue(null);
    setSearchedLabel([]);
    setReserveCustomerId("");
    setSearchMailReciever(null);
    setSearchMailSender(null);
    setSearchMailSubject("");
    setSearchMailDate("");
    setSearchMailTemplateSelect([]);
    setSearchMailLabelSelect([]);
    setSearchMailReserveId("");
    setReloadConversationList(true);
  };
  // Hook for date compare validation
  const [dateWarning, setDateWarning] = useState(false);
  const [noFilterWarning, setNoFilterWarning] = useState(false);

  //function for search
  const searchHandler = () => {
    // check if at least one filter is selected
    const hasFilter =
      selectedChecked !== "" ||
      recieverValue ||
      senderValue ||
      mailSubject !== "" ||
      searchedTemplate.length > 0 ||
      searchedLabel.length > 0 ||
      reserveCustomerId !== "";

    if (!hasFilter) {
      setNoFilterWarning(true);
      return;
    }
    setNoFilterWarning(false);

    //assign data for search
    recieverValue && setSearchMailReciever(recieverValue?.value);
    senderValue && setSearchMailSender(senderValue?.value);
    setSearchMailSubject(mailSubject);
    setSearchMailTemplateSelect(searchedTemplate);
    setSearchMailLabelSelect(searchedLabel);
    setSearchMailReserveId(reserveCustomerId);

    /*===== switch statement for date input radio start ======*/
    switch (selectedChecked) {
      case "daterange":
        if (fromDate <= toDate) {
          setSearchMailDate(fromDate + "," + toDate);
        } else {
          setDateWarning(true);
        }
        break;

      case "todayradio":
        setSearchMailDate(todayValue);
        break;

      case "eventdate":
        setSearchMailDate(selectedDate);
        break;

      default:
        setSearchMailDate("");
        break;
    }
    /*===== switch statement for date input radio end ======*/
  };

  //use effect for search receiver
  useEffect(() => {
    if (recieverName.length >= 3) {
      getAllRecieverList();
    }
  }, [recieverName]);

  //use effect for search sender
  useEffect(() => {
    if (senderName.length >= 3) {
      getAllSenderList();
    }
  }, [senderName]);

  useEffect(() => {
    getAllTemplates();
    getAllLabels();
  }, []);

  return (
    <div className="collapse mt-3" id="filterMailCollapse">
      <div className="p-3 bg-gray-200">
        <form onSubmit={(e) => e.preventDefault()}>

          {/* ===== BLOCK 1 : Filter by Date ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>calendar_month</span>
              {t("Filter by Date")}
            </p>
            <div className="row g-3 align-items-start">

              {/* a) Range */}
              <div className="col-lg-6">
                <div
                  className={`border rounded p-2 h-100 ${selectedChecked === "daterange" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedChecked("daterange"); setDateWarning(false); }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <input
                      className="form-check-input mt-0"
                      type="radio"
                      name="dateGroup"
                      id="dateRange"
                      value="daterange"
                      checked={selectedChecked === "daterange"}
                      onChange={radioCheckHandler}
                    />
                    <label className="form-check-label fw-medium mb-0" htmlFor="dateRange" style={{ cursor: "pointer" }}>
                      {t("Range")}
                    </label>
                  </div>
                  <div className="d-sm-flex gap-2">
                    <input
                      type="date"
                      id="from_date"
                      className="form-control form-control-sm bg-white"
                      value={fromDate}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => { setFromDate(e.target.value); setDateWarning(false); setSelectedChecked("daterange"); setNoFilterWarning(false); }}
                    />
                    <input
                      type="date"
                      id="to_date"
                      className="form-control form-control-sm bg-white mt-2 mt-sm-0"
                      value={toDate}
                      onClick={(e) => e.stopPropagation()}
                      onChange={(e) => { setToDate(e.target.value); setDateWarning(false); setSelectedChecked("daterange"); setNoFilterWarning(false); }}
                    />
                  </div>
                  {dateWarning && (
                    <p className="d-flex align-items-center gap-1 text-danger small mb-0 mt-1">
                      <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>warning</span>
                      {t("End date should be greater than start date")}!
                    </p>
                  )}
                </div>
              </div>

              {/* b) Today */}
              <div className="col-lg-3">
                <div
                  className={`border rounded p-2 h-100 d-flex align-items-center gap-2 ${selectedChecked === "todayradio" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedChecked("todayradio"); setDateWarning(false); }}
                >
                  <input
                    className="form-check-input mt-0"
                    type="radio"
                    name="dateGroup"
                    id="today"
                    value="todayradio"
                    checked={selectedChecked === "todayradio"}
                    onChange={radioCheckHandler}
                  />
                  <label className="form-check-label fw-medium mb-0" htmlFor="today" style={{ cursor: "pointer" }}>
                    <span className="material-symbols-outlined align-middle me-1" style={{ fontSize: "16px" }}>today</span>
                    {t("Today")}
                  </label>
                </div>
              </div>

              {/* c) Selected Date */}
              <div className="col-lg-3">
                <div
                  className={`border rounded p-2 h-100 ${selectedChecked === "eventdate" ? "border-primary bg-primary bg-opacity-10" : ""}`}
                  style={{ cursor: "pointer" }}
                  onClick={() => { setSelectedChecked("eventdate"); setDateWarning(false); }}
                >
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <input
                      className="form-check-input mt-0"
                      type="radio"
                      name="dateGroup"
                      id="specificDate"
                      value="eventdate"
                      checked={selectedChecked === "eventdate"}
                      onChange={radioCheckHandler}
                    />
                    <label className="form-check-label fw-medium mb-0" htmlFor="specificDate" style={{ cursor: "pointer" }}>
                      {t("Selected Date")}
                    </label>
                  </div>
                  <input
                    type="date"
                    id="specific_date"
                    className="form-control form-control-sm bg-white"
                    value={selectedDate}
                    onClick={(e) => e.stopPropagation()}
                    onChange={(e) => { setSelectedDate(e.target.value); setSelectedChecked("eventdate"); setNoFilterWarning(false); }}
                  />
                </div>
              </div>

            </div>
          </div>
          {/* ===== END BLOCK 1 ===== */}

          {/* ===== BLOCK 2 : Reserve ID, Template, Label ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>filter_list</span>
              {t("Filter by Reserve & Category")}
            </p>
            <div className="row g-3">
              {/* Reserve Customer ID */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Reserve Customer ID")}</label>
                <div className="position-relative">
                  <input
                    type="text"
                    placeholder={t("e.g. 10045")}
                    className="form-control bg-white"
                    value={reserveCustomerId}
                    onChange={(e) => setReserveCustomerId(e.target.value)}
                  />
                  <span className="material-symbols-outlined position-absolute top-50 end-0 translate-middle-y me-2 text-muted" style={{ fontSize: "18px" }}>
                    tag
                  </span>
                </div>
              </div>

              {/* Mail Template */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Mail Template")}</label>
                <Select
                  isMulti
                  placeholder={t("Select template")}
                  options={templateList}
                  value={templateValue}
                  onChange={(val) => templateSectionHandler(val)}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>

              {/* Label */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Label")}</label>
                <Select
                  isMulti
                  placeholder={t("Select label")}
                  options={labelList}
                  value={labelValue}
                  onChange={(val) => labelSectionHandler(val)}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>
            </div>
          </div>
          {/* ===== END BLOCK 2 ===== */}

          {/* ===== BLOCK 3 : Receiver, Sender, Subject ===== */}
          <div className="border rounded p-3 mb-3 bg-white">
            <p className="text-muted small fw-semibold text-uppercase mb-2 d-flex align-items-center gap-1">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>people</span>
              {t("Filter by Participants & Subject")}
            </p>
            <div className="row g-3">
              {/* Receiver */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Receiver")}</label>
                <Select
                  placeholder={t("Search receiver...")}
                  options={recieverList}
                  value={recieverValue}
                  onChange={(val) => recieverSelectionHandler(val)}
                  onInputChange={(val) => setRecieverName(val)}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>

              {/* Sender */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Sender")}</label>
                <Select
                  placeholder={t("Search sender...")}
                  options={senderList}
                  value={senderValue}
                  onChange={(val) => senderSelectionHandler(val)}
                  onInputChange={(val) => setSenderName(val)}
                  menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                />
              </div>

              {/* Subject */}
              <div className="col-lg-4">
                <label className="form-label small text-muted mb-1">{t("Subject")}</label>
                <div className="position-relative">
                  <input
                    type="text"
                    placeholder={t("Search by subject...")}
                    className="form-control bg-white"
                    value={mailSubject}
                    onChange={(e) => setmailSubject(e.target.value)}
                  />
                  <span className="material-symbols-outlined position-absolute top-50 end-0 translate-middle-y me-2 text-muted" style={{ fontSize: "18px" }}>
                    search
                  </span>
                </div>
              </div>
            </div>
          </div>
          {/* ===== END BLOCK 3 ===== */}

          {/* ===== Actions ===== */}
          {noFilterWarning && (
            <p className="d-flex align-items-center gap-1 text-danger small mb-2 justify-content-end">
              <span className="material-symbols-outlined" style={{ fontSize: "16px" }}>warning</span>
              {t("Please select at least 1 filter parameter before applying.")}
            </p>
          )}
          <div className="d-flex gap-3 align-items-center justify-content-end">
            <Link
              to="#"
              className="d-flex gap-1 align-items-center text-secondary"
              onClick={resetHandler}
            >
              <span className="material-symbols-outlined icon-md">sync</span>
              <span className="fw-medium">{t("Reset")}</span>
            </Link>
            <button
              className="btn btn-primary px-4 d-flex align-items-center gap-2"
              onClick={searchHandler}
              disabled={isConversationLoading}
            >
              {isConversationLoading ? (
                <>
                  <span
                    className="spinner-border spinner-border-sm"
                    role="status"
                    aria-hidden="true"
                  />
                  {t("Loading...")}
                </>
              ) : (
                <>
                  <span className="material-symbols-outlined align-middle" style={{ fontSize: "18px" }}>search</span>
                  {t("Apply Filter")}
                </>
              )}
            </button>
          </div>
          {/* ===== End Actions ===== */}

        </form>
      </div>
    </div>
  );
};

export default ConversationFilter;
